const Pagination = ({totalCount, pageCount, currentPage, setCurrentPage, setPaging}) => {
    let list = [];
    if (totalCount === 0) return;
    let paginations = Math.ceil(totalCount / pageCount);

    for (let i = 0; i < paginations; i++) {
        // 1. 페이지 그려주는 경우
        // 2. 생략버튼 그려주는 경우(맨 앞만 ... 인 경우 현재페이지 중간이라 앞뒤로 ...인경우 맨 뒤만 ...인경우)
        let renderPage = i + 1;
        if (renderPage === 1 || renderPage === paginations
            || (currentPage < 4 && renderPage < 5)
            || (currentPage > 3 && currentPage <= renderPage && renderPage < currentPage + 3)
            || (currentPage > paginations - 3 && renderPage > paginations - 4)) {
            list.push(
                <li key={i}><a href={() => { }} className={currentPage === renderPage ? 'on' : ''} onClick={e => setCurrentPage(renderPage)}>{renderPage}</a></li>
            );
        } else if ((renderPage === 2 && currentPage > paginations - 3)
            || (renderPage === currentPage - 1 && renderPage < currentPage)
            || renderPage === paginations - 1) {
            list.push(
                <li key={i}><a href={() => { }} className="ellipsis" ><i className="i-ellipsis"></i></a></li>
            );
        }
    }
    return (
        <div className="pagination">
            <button className="btn prev"
                style={{ visibility: currentPage !== 1 ? 'visible' : 'hidden' }}
                onClick={e => setPaging('prev')}>
                <i className="i-paging-arrow"></i>
            </button>
            <ol>
                {list}
            </ol>
            <button className="btn next"
                style={{ visibility: currentPage !== paginations ? 'visible' : 'hidden' }}
                onClick={e => setPaging('next')}>
                <i className="i-paging-arrow"></i>
            </button>
        </div>
    );
};
export default Pagination;